jQuery(document).ready(function ($) {
    "use strict";

    var headerHeight = $('.main-header').outerHeight() - 62,
        footerHeight = $('.main-footer').outerHeight();
    // Enable smooth anchor link scrolling
    // on all link elements (href="#...")
    $.localScroll({
        target: 'body',
        offset: -1 * headerHeight
    });

    // Enable Flickity for all elements with
    // Flickity data attribute. Setting overrides
    // must be set as json string on attribute
    $('[data-flickity]').flickity({
        wrapAround: true,
        imagesLoaded: true
    });

    // Enable Flickity for image-with-links block
    // only on mobile
    // var $window = jQuery(window);
    // var $imageWithLinks = $('.images-with-links');

    // function checkWidth() {
    //     var windowSize = $window.width();

    //     if (windowSize < 640) {
    //         $imageWithLinks.flickity({
    //             wrapAround: true,
    //             imagesLoaded: true,
    //             pageDots: false
    //         });
    //     } else {
    //         $imageWithLinks.flickity('destroy');
    //     };
    // };

    // checkWidth();

    // jQuery(window).bind('resize', checkWidth);


    var roomSlider = $('[data-rooms-flickity]').flickity({
        wrapAround: true,
        cellAlign: 'center',
        pageDots: false,
        draggable: false
    });

    var roomSlider = $('[data-events-flickity]').flickity({
        wrapAround: true,
        cellAlign: 'left',
        pageDots: false,
        draggable: true,
        autoPlay: 5000
    });

    $('#nav-icon').click(function () {
        $(this).toggleClass('open');
    });

    $('.burger-menu').click(function () {
        $(this).toggleClass('change');
    })

    // Set element heights to viewport height
    // (Accepts ratios eg data-full-height="0.5")
    // $('[data-full-height]').fullHeight();

    // Automatically add waypoint classes to
    // elements on scroll
    // $('[data-waypoint]').waypointClasses();

    // Sticky placeholder full support
    // $('.sticky-placeholder').stickyPlaceholder();

    // Room picker script to select which content to show based on selected title slide

    // init value
    var selectedVal = $('.rooms__titles-slider .is-selected').data('selected');
    $('.rooms .rooms__content').each(function () {
        if (selectedVal !== $(this).data('selected')) {
            $(this).hide();
        } else {
            $(this).show();
        }
    });

    roomSlider.on('settle.flickity', function () {
        var selectedVal = $('.rooms__titles-slider .is-selected').data('selected');

        $('.rooms .rooms__content, .rooms .rooms__gallery-image').each(function () {
            var self = $(this);
            if (selectedVal !== $(this).data('selected')) {
                $(self).fadeOut();
            } else {
                setTimeout(function () {
                    $(self).fadeIn();
                }, 400);
            }
        });
    });

    // Function to set the padding of the nav bar on scroll...
    function navPadding() {
        var windowPos = $(window).scrollTop();
        var delta = 1420;
        var designPaddingTop = 3.5
        var designPaddingBottom = 2.5
        var headerPaddingTop = ((delta - windowPos) / delta) * designPaddingTop;
        var headerPaddingBottom = ((delta - windowPos) / delta) * designPaddingBottom;
        if (headerPaddingTop >= 1.25) {
            $('.main-header').css({ 'padding': headerPaddingTop + 'rem 0 ' + headerPaddingBottom + 'rem' })
        }
    }

    // Do stuff on window scroll...
    $(window).on('scroll', function () {
        navPadding();
    });

    // Scroll bottom function
    $.fn.scrollBottom = function () {
        return ($(document).height() - this.scrollTop() - this.height());
    };

    function animatePageArrow() {
        var offset = 60;

        $(window).on('scroll', function () {

            if ($(window).scrollTop() > offset) {
                $('.page-arrow').css('bottom', '-60px');
            } else {
                $('.page-arrow').css('bottom', '20px');
            }

            if ($(window).scrollBottom() < 30) {
                $('.page-arrow').css('display', 'none');
            } else {
                $('.page-arrow').css('display', 'block');
            }

        });
    }

    // If page arrow exists, animate
    if ($('.page-arrow').length) {
        animatePageArrow();
    }

    // Toggle Nav display on menu--link--open button press...
    $(".menu--link--open").click(function () {
        $('.main-header__nav').toggleClass('hidden');
        $('.main-content').toggleClass('main-content-blur');
        $('.main-header').toggleClass('borders');
        $('.main-header').toggleClass(' main-header__hidden');
    });

    $('[data-map]').gMap();

    // Opens Magnific Popup's, using the data attribute to group items into a gallery,
    // For dynamic type to work, you will need to add the class mfp-TYPE to all elements.
    // Use mfp-image for images, mfp-iframe for videos, and mfp-inline for HTML.
    /* Look at this further, can be more efficient. */
    $('[data-mfp]').on('click', function (e) {
        e.preventDefault();

        $('[data-mfp]').magnificPopup({
            gallery: {
                enabled: true
            }
        }).magnificPopup('open');
    });


    // Ajax Load More JS

    /*
    * alm_adv_filter()
    * https://connekthq.com/plugins/ajax-load-more/examples/filtering/advanced-filtering/
    *
    */

    var alm_is_animating = false;

    function alm_adv_filter() {

        if (alm_is_animating) {
            return false; // Exit if filtering is still active
        }

        alm_is_animating = true;

        var obj = {},
            count = 0;

        // Loop each filter menu
        $('.blog__filters').each(function (e) {
            var menu = $(this),
                type = menu.data('type'), // type of filter elements (checkbox/radio/select)
                parameter = menu.data('parameter'), // category/tag/year
                value = '',
                count = 0;

            // Loop each item in the menu
            if (type === 'checkbox' || type === 'radio') { // Checkbox or Radio
                $('input:checked', menu).each(function () {
                    count++;
                    var el = $(this);

                    // Build comma separated string of items
                    if (count > 1) {
                        value += ',' + el.val();
                    } else {
                        value += el.val();
                    }
                });
            }

            if (type === 'select') { // Select
                var select = $(this);
                value += select.val();
            }

            obj[parameter] = value; // add value(s) to obj

        });

        console.log(obj);

        var data = obj;
        $.fn.almFilter('fade', '300', data); // Send data to Ajax Load More
    }

    $('.blog__filters').on('change', alm_adv_filter); // 'Apply Filter' button click




    var alm_is_animating = false;

    function alm_adv_filter_event() {

        if (alm_is_animating) {
            return false; // Exit if filtering is still active
        }

        alm_is_animating = true;

        var obj = {},
            count = 0;

        // Loop each filter menu
        $('.events__filters').each(function (e) {
            var menu = $(this),
                type = menu.data('type'), // type of filter elements (checkbox/radio/select)
                parameter = menu.data('parameter'), // category/tag/year
                value = '',
                count = 0;

            // Loop each item in the menu
            if (type === 'checkbox' || type === 'radio') { // Checkbox or Radio
                $('input:checked', menu).each(function () {

                    // var data = $(this).data();

                    count++;
                    var el = $(this);

                    // Build comma separated string of items
                    if (count > 1) {
                        value += ',' + el.val();
                    } else {
                        value += el.val();
                    }
                });
            }

            if (type === 'select') { // Select
                var select = $(this);
                value += select.val();
                var data = $(this).data();
            }

            obj[parameter] = value; // add value(s) to obj

        });

        console.log(obj);

        // var data = obj;
        $.fn.almFilter('fade', '300', data); // Send data to Ajax Load More
    }

    $('.events__filters').on('change', function () {
        var selected = $(this).find('option:selected');
        console.log(selected.data());
        $.fn.almFilter('fade', '300', selected.data());
    }); // 'Apply Filter' button click



    /*
    * almFilterComplete()
    * Callback function sent from core Ajax Load More
    */
    $.fn.almFilterComplete = function () {
        alm_is_animating = false; // clear animating flag
    };


    // Tito widget functionality
    $('.content-block__widget-button').on('click', function (e) {
        e.preventDefault();
        var widgetContainer = $(this).parent().find('.content-block__widget');
        widgetContainer.toggleClass('visible');
    });

    $('.content-block__widget-close').on('click', function () {
        var widgetContainer = $(this).parent();
        widgetContainer.toggleClass('visible');
    });

});
